import React from 'react'
import { Modal } from 'antd';

export function AntModal({ children, isOpen, onClose, title, hasFooter = null, options = {} }) {
    return (
        <Modal
            title={title}
            open={isOpen}
            onCancel={onClose}
            footer={hasFooter}
            {...options}
        >
            {children}
        </Modal>
    )
}
